// Copyright 2024 - MinIO, Inc. All rights reserved.

import React, { Fragment } from "react";
import { Box, Button, FormLayout } from "mds";

const SetupComplete = () => {
  return (
    <Fragment>
      <Box sx={{ marginBottom: 16 }}>
        This site has successfully joined your main control plane. You may now
        close this window and start managing this site remotely.
      </Box>
      <Box sx={{ width: "100%" }}>
        <FormLayout withBorders={false} containerPadding={false}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                id={"exit-setup"}
                type={"button"}
                onClick={() => (window.location.href = "/")}
                variant={"callAction"}
              >
                Exit Setup
              </Button>
            </Box>
          </form>
        </FormLayout>
      </Box>
    </Fragment>
  );
};
export default SetupComplete;
